import React, { useState, useEffect } from "react";
import axios from "axios";
import { Form } from "react-bootstrap";
import swal from "sweetalert";

import "@fortawesome/fontawesome-free/css/all.min.css";
import BASE_URL from "../../../../../../assets/global/url";
import "../../../../../../assets/css/style.css";

import useExchangeProfitLoss from "../../../../../../hooks/useExchangeProfitLoss";
import { useServerPagination } from "../../../../../../hooks/customHook/paginationHook/useServerPagination";
import { PaginationControls } from "../../../../../../hooks/customHook/paginationHook/usePagination";
import DateRangePicker from "../../../../../../components/DateRangePicker";
import {
  getMonthBoundaries,
  initializeCutoff,
} from "../../../../../../utils/newdate.js";
import {
  formatCurrency,
  formatToPHP,
} from "../../../../../../utils/numberFormatter.js";

const ForecastedPL = ({ authrztn, fromDate, toDate }) => {
  const boundaries = getMonthBoundaries();
  const cutoffBoundaries = { start: new Date(fromDate), end: new Date(toDate) };
  const initialDateRange = fromDate && toDate ? cutoffBoundaries : boundaries;
  const initialDate = initializeCutoff(initialDateRange);

  // const formatDateOnly = (date) => date.toISOString().split("T")[0];

  // const [p_L_data, setP_L_Data] = useState([]);
  // const [allP_L_data, setAllP_L_Data] = useState([]);
  const [totalGainLossInfos, setTotalGainLossInfos] = useState({
    previous_cutoff_gain_loss: 0,
    current_cutoff_gain_loss: 0,
    overall_gain_loss: 0,
    previous_cutoff_percentage: 0,
    current_cutoff_percentage: 0,
    overall_gain_percentage: 0,
  });

  const [dateRangefilter, setDateRangeFilter] = useState({
    from: initialDate?.from,
    to: initialDate?.to,
  });

  // Initialize pagination
  const pagination = useServerPagination(
    `${BASE_URL}/profit_loss/forecast/getData`,
    10,
    {
      date_from: dateRangefilter?.from,
      date_to: dateRangefilter?.to,
    },
  );

  // console.log("Date Range Filter:", dateRangefilter);

  // console.log("Pagination Data:", pagination.data);

  // Fetch all P&L data for total
  // const fetchAllP_L_Data = () => {
  //   if (dateRangefilter.from && dateRangefilter.to) {
  //     axios
  //       .get(BASE_URL + "/profit_loss/getJournalv2DataTotals", {
  //         params: {
  //           date_from: dateRangefilter?.from,
  //           date_to: dateRangefilter?.to,
  //         },
  //       })
  //       .then((res) => {
  //         setAllP_L_Data(res.data);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   }
  // };

  const getTotalGainLossInfos = () => {
    axios
      .get(BASE_URL + "/profit_loss/forecast/getWidgetForcastedPL", {
        params: {
          date_from: dateRangefilter?.from,
          date_to: dateRangefilter?.to,
        },
      })
      .then((res) => {
        setTotalGainLossInfos((prev) => {
          const prevGain = res.data.previousWidgetPL || 0;
          const prevPercent = res.data.previousWidgetPercent || 0;
          // const currGain = res.data.currentWidgetPL || 0;
          // const currPercent = res.data.currentWidgetPercent || 0;
          const overallWidgetPL = res.data.overallWidgetPL || 0;
          const overallWidgetPercent = res.data.overallWidgetPercent || 0;

          return {
            previous_cutoff_gain_loss: prevGain,
            previous_cutoff_percentage: prevPercent,
            // current_cutoff_gain_loss: currGain,
            // current_cutoff_percentage: currPercent,
            overall_gain_loss: overallWidgetPL,
            overall_gain_percentage: overallWidgetPercent,
          };
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Update pagination when dates change
  useEffect(() => {
    if (dateRangefilter?.from && dateRangefilter?.to) {
      // fetchAllP_L_Data();
      getTotalGainLossInfos();
    }
  }, [dateRangefilter?.from, dateRangefilter?.to]);

  // Update p_L_data when pagination data changes
  // useEffect(() => {
  //   setP_L_Data(pagination.data);
  // }, [pagination.data]);

  // const { rows, totalPL, totalPercent } = useExchangeProfitLoss(
  //   pagination.data
  // );
  // const {
  //   rows: allRows,
  //   totalPL: allTotalPL,
  //   totalPercent: allTotalPercent,
  // } = useExchangeProfitLoss(allP_L_data);

  // const handleDateRangeChange = (startDate, endDate) => {
  //   onDateRangeChange(startDate, endDate);
  //   pagination.setCurrentPage(1);
  // };

  const handleDateRangeChange = (startDate, endDate) => {
    setDateRangeFilter({
      from: startDate,
      to: endDate,
    });

    pagination.updateParams({
      date_from: startDate,
      date_to: endDate,
    });

    getTotalGainLossInfos();
    // fetchAllP_L_Data();
  };

  // console.log("Updated Date Range Filter:", dateRangefilter);

  return (
    <div>
      <div className="w-100 row mx-auto mt-2">
        <h6>Accounting Period</h6>
        <div className="col-sm mb-2">
          <DateRangePicker
            defaultDateRange={fromDate && toDate && cutoffBoundaries}
            onDateRangeChange={handleDateRangeChange}
            label="Accounting Period"
          />
        </div>
        <div className="col-sm"></div>
      </div>

      {/* Summary Cards */}
      <div className="row g-3 mb-4">
        <div className="col-md">
          <div
            className="card shadow-sm border-0 h-100"
            style={{ transition: "box-shadow 0.3s" }}
          >
            <div className="card-body">
              <div className="small text-muted fw-medium mb-2">
                Previous Cutoffs
              </div>
              <div className="d-flex align-items-center">
                <h3
                  className="mb-0 me-2"
                  style={{
                    color:
                      totalGainLossInfos.previous_cutoff_gain_loss >= 0
                        ? "var(--pl-gain-color, #16a34a)"
                        : "var(--pl-loss-color, #dc2626)",
                    fontWeight: "700",
                  }}
                >
                  {`${formatToPHP(totalGainLossInfos.previous_cutoff_gain_loss)} (${totalGainLossInfos.previous_cutoff_percentage.toFixed(
                    2,
                  )}%)`}
                </h3>
                <i
                  className={`fas fa-arrow-trend-${
                    totalGainLossInfos.previous_cutoff_gain_loss >= 0
                      ? "up"
                      : "down"
                  }`}
                  style={{
                    color:
                      totalGainLossInfos.previous_cutoff_gain_loss >= 0
                        ? "var(--pl-gain-color, #16a34a)"
                        : "var(--pl-loss-color, #dc2626)",
                  }}
                ></i>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="col-md-4">
          <div
            className="card shadow-sm border-0 h-100"
            style={{ transition: "box-shadow 0.3s" }}
          >
            <div className="card-body">
              <div className="small text-muted fw-medium mb-2">
                Current Cutoff
              </div>
              <div className="d-flex align-items-center">
                <h3
                  className="mb-0 me-2"
                  style={{
                    color:
                      totalGainLossInfos.current_cutoff_gain_loss >= 0
                        ? "#16a34a"
                        : "#dc2626",
                    fontWeight: "700",
                  }}
                >
                  {`${formatNumber(
                    totalGainLossInfos.current_cutoff_gain_loss,
                    "PHP"
                  )} (${totalGainLossInfos.current_cutoff_percentage.toFixed(
                    2
                  )}%)`}
                </h3>
                <i
                  className={`fas fa-arrow-trend-${
                    totalGainLossInfos.current_cutoff_gain_loss >= 0
                      ? "up"
                      : "down"
                  }`}
                  style={{
                    color:
                      totalGainLossInfos.current_cutoff_gain_loss >= 0
                        ? "#16a34a"
                        : "#dc2626",
                  }}
                ></i>
              </div>
            </div>
          </div>
        </div> */}
        <div className="col-md">
          <div
            className="card shadow-sm border-0 h-100"
            style={{ transition: "box-shadow 0.3s" }}
          >
            <div className="card-body">
              <div className="small text-muted fw-medium mb-2">
                Overall Cutoff
              </div>
              <div className="d-flex align-items-center">
                <h3
                  className="mb-0 me-2"
                  style={{
                    color:
                      totalGainLossInfos.overall_gain_loss >= 0
                        ? "var(--pl-gain-color, #16a34a)"
                        : "var(--pl-loss-color, #dc2626)",
                    fontWeight: "700",
                  }}
                >
                  {`${formatToPHP(totalGainLossInfos.overall_gain_loss)} (${totalGainLossInfos.overall_gain_percentage.toFixed(
                    2,
                  )}%)`}
                </h3>
                <i
                  className={`fas fa-arrow-trend-${
                    totalGainLossInfos.overall_gain_loss >= 0 ? "up" : "down"
                  }`}
                  style={{
                    color:
                      totalGainLossInfos.overall_gain_loss >= 0
                        ? "var(--pl-gain-color, #16a34a)"
                        : "var(--pl-loss-color, #dc2626)",
                  }}
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Transactions Table */}
      <div className="card shadow-sm border-0">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead
                style={{ backgroundColor: "var(--report-th-bg, #f8f9fa)" }}
              >
                <tr>
                  <th className="px-4 py-3 text-muted small fw-semibold text-uppercase">
                    Module From
                  </th>
                  <th className="px-4 py-3 text-muted small fw-semibold text-uppercase text-end">
                    Amount From
                  </th>
                  <th className="px-4 py-3 text-muted small fw-semibold text-uppercase text-end">
                    Received Rate
                  </th>
                  <th className="px-4 py-3 text-muted small fw-semibold text-uppercase text-end">
                    Received Amount (Assumed)
                  </th>
                  <th className="px-4 py-3 text-muted small fw-semibold text-uppercase text-end">
                    System Rate
                  </th>
                  <th className="px-4 py-3 text-muted small fw-semibold text-uppercase text-end">
                    System Amount
                  </th>
                  <th className="px-4 py-3 text-muted small fw-semibold text-uppercase text-end">
                    P/L (₱)
                  </th>
                  <th className="px-4 py-3 text-muted small fw-semibold text-uppercase text-end">
                    P/L (%)
                  </th>
                </tr>
              </thead>
              <tbody>
                {pagination?.data.map((r, i) => {
                  const moduleData = r.module;
                  const transaction_rate = r.transaction_rate;
                  const currency_name = r.currency_name;
                  const original_amount = r.original_amount;
                  const system_rate = r.system_rate;

                  const assumed_rate_amount =
                    original_amount * transaction_rate;
                  const actual_rate_amount = original_amount * system_rate;

                  const profitLossPHP =
                    actual_rate_amount - assumed_rate_amount;
                  const percentPL =
                    assumed_rate_amount !== 0
                      ? (profitLossPHP / assumed_rate_amount) * 100
                      : 0;

                  return (
                    <tr key={i}>
                      <td className="px-4 py-3">{moduleData}</td>
                      <td className="px-4 py-3 text-end fw-medium">
                        {formatCurrency(original_amount, currency_name)}
                      </td>
                      <td className="px-4 py-3 text-end text-muted">
                        {formatToPHP(transaction_rate)}
                      </td>
                      <td className="px-4 py-3 text-end text-muted">
                        {formatToPHP(assumed_rate_amount)}
                      </td>
                      <td className="px-4 py-3 text-end fw-medium">
                        {formatToPHP(system_rate)}
                      </td>
                      <td className="px-4 py-3 text-end fw-medium">
                        {formatToPHP(actual_rate_amount)}
                      </td>
                      <td className="px-4 py-3 text-end">
                        <span
                          className="badge rounded-pill px-3 py-2"
                          style={{
                            backgroundColor:
                              profitLossPHP >= 0 ? "#dcfce7" : "#fee2e2",
                            color: profitLossPHP >= 0 ? "#16a34a" : "#dc2626",
                            fontWeight: "600",
                          }}
                        >
                          {profitLossPHP >= 0 ? "+" : "-"}{" "}
                          {formatToPHP(Math.abs(profitLossPHP))}
                        </span>
                      </td>

                      <td className="px-4 py-3 text-end">
                        <span
                          className="badge rounded-pill px-3 py-2"
                          style={{
                            backgroundColor:
                              percentPL >= 0 ? "#dcfce7" : "#fee2e2",
                            color: percentPL >= 0 ? "#16a34a" : "#dc2626",
                          }}
                        >
                          {percentPL >= 0 ? "+" : "-"}{" "}
                          {Math.abs(percentPL).toFixed(2)}%
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>

              {/* <tfoot
                style={{
                  backgroundColor: "var(--report-th-bg, #f8f9fa)",
                  borderTop: "2px solid var(--report-th-border, #dee2e6)",
                }}
              >
                <tr>
                  <td
                    colSpan="6"
                    className="px-4 py-3 text-end fw-bold text-uppercase small"
                  >
                    Total Profit / Loss:
                  </td>

                  <td className="px-4 py-3 text-end">
                    <span
                      className="badge rounded-pill px-3 py-2"
                      style={{
                        backgroundColor: totalPL >= 0 ? "#d1fae5" : "#fecaca",
                        color: totalPL >= 0 ? "#16a34a" : "#dc2626",
                        fontWeight: "700",
                        fontSize: "1.5rem",
                      }}
                    >
                      {formatNumber(totalPL, "PHP")}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-end">
                    <span
                      className="badge rounded-pill px-3 py-2"
                      style={{
                        backgroundColor:
                          totalPercent >= 0 ? "#dcfce7" : "#fee2e2",
                        color: totalPercent >= 0 ? "#16a34a" : "#dc2626",
                        fontSize: "1.5rem",
                      }}
                    >
                      {totalPercent.toFixed(2)}%
                    </span>
                  </td>
                </tr>
              </tfoot> */}
            </table>
          </div>
        </div>
      </div>
      {/*<PaginationControls {...pagination} />*/}
    </div>
  );
};

export default ForecastedPL;
